import { Collapse } from "antd";
import React, { useContext } from "react";
import { AppContext } from "../../../context";

function Conditions({ conditions, typology }) {
  const info = useContext(AppContext);
  const { Panel } = Collapse;

  return conditions && Object.keys(conditions).length > 0 ? (
    <div className="ahp-rentacar-cond" style={{ marginTop: 10 }}>
      <Collapse bordered={false}>
        <Panel header={info.t("conditionsFor")}>
          {Object.entries(conditions).map(([key, value]) => (
            <div>
              {info.t(key)}: {value} €
            </div>
          ))}
        </Panel>
      </Collapse>
    </div>
  ) : (
    <div></div>
  );
}

export default Conditions;
